/**
 *
 * QualificationDetails
 *
 */

import React, { memo, FunctionComponent, useState } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import {
  ComponentDialogBody,
  StyledDialogActionsBar,
  StyledModalAction,
} from '../../../../components/DiaogWrap/styles';
import { Column, Row, Wrap } from '../../../../assets/styledAssets/grid';
import {
  StyledDropDownList,
  StyledLabel,
} from '../../../../components/FormField/styles';
import { Qualification, QualificationLevel } from '../../qualification';
import { DropdownResponse } from '../../../../domains/app';

interface IProps {
  onCancel: () => void;
  onSave: (d: Partial<Qualification>) => void;
  testTypeList: DropdownResponse[];
  qualification?: Qualification;
}

const QualificationDetails: FunctionComponent<IProps> = ({
  onCancel,
  onSave,
  qualification,
  testTypeList,
}) => {
  const intl = useIntl();
  const [details, setDetails] = useState<Partial<Qualification>>(
    qualification || {},
  );
  const [listLevels] = useState([
    QualificationLevel.Instructor,
    QualificationLevel.Tester,
  ]);

  const itemRender = (element: any, value: any) => {
    if (value === undefined) {
      return element;
    }

    const itemChildren = (
      <span>
        {intl.formatMessage(
          value === QualificationLevel.Instructor
            ? messages.instructor
            : messages.tester,
        )}
      </span>
    );

    return React.cloneElement(element, element.props, itemChildren);
  };

  return (
    <>
      <ComponentDialogBody>
        <Row>
          <Wrap margin={'0 0 3rem'} width={'100%'}>
            <Column xs={100} md={100}>
              <StyledLabel>{intl.formatMessage(messages.test)}</StyledLabel>
              <StyledDropDownList
                data={testTypeList}
                textField={'name'}
                dataItemKey={'id'}
                value={details?.testType}
                onChange={(e) =>
                  setDetails({ ...details, testType: e.value })
                }
                disabled={!!details?.id}
              />
            </Column>
          </Wrap>
          <Wrap margin={'0 0 3rem'} width={'100%'}>
            <Column xs={100} md={100}>
              <StyledLabel>{intl.formatMessage(messages.level)}</StyledLabel>
              <StyledDropDownList
                data={listLevels}
                value={details?.level}
                onChange={(e) => {

                  setDetails({ ...details, level: e.value })
                }}
                itemRender={(e, d) => itemRender(e, d.dataItem)}
                valueRender={itemRender}
              />
            </Column>
          </Wrap>
        </Row>
      </ComponentDialogBody>
      <StyledDialogActionsBar>
        <StyledModalAction onClick={onCancel}>
          {intl.formatMessage(messages.cancel)}
        </StyledModalAction>
        <StyledModalAction accent onClick={() => onSave(details)}>
          {intl.formatMessage(messages.save)}
        </StyledModalAction>
      </StyledDialogActionsBar>
    </>
  );
};

export default memo(QualificationDetails);
